import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-900 text-gray-300 border-t border-zinc-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <div className="bg-white rounded-lg p-2 hover:shadow-lg hover:shadow-orange-500/30 transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_adelaide-tipper-hire/artifacts/mery91eo_Af991094c974f4b6c8993f17f1aee4d36N.png"
                  alt="Adelaide Hills Tipper Hire Logo"
                  className="h-10 w-auto"
                />
              </div>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              Professional tipper hire services for Adelaide Hills, Murray Bridge and surrounding areas. Reliable, efficient, and experienced.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-orange-500 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-orange-500 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-orange-500 transition-colors">Gallery</Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-orange-500 transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <a href={`tel:${businessInfo.phone}`} className="text-sm hover:text-orange-500 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="text-sm hover:text-orange-500 transition-colors break-all">
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-orange-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{businessInfo.serviceArea}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Adelaide Hills Tipper Hire. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <Link to="/privacy-policy" className="hover:text-orange-500 transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-service" className="hover:text-orange-500 transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
